import React from 'react';

const counterBlog = [
    {
        icon: 'fa-user-graduate',
        value: 'Student Talent',
        suffix: '+',
        title: 'Student-Crafted Creations',
        subtitle: 'Every product is handmade by talented students, making each item unique and meaningful.'
    },
    {
        icon: 'fa-palette',
        value: "Quality",
        suffix: '+',
        title: 'Curated Quality Products',
        subtitle: 'All handmade items are carefully reviewed to ensure quality and creativity.'
    },
    {
        icon: 'fa-gift',
        value: "Gifting",
        suffix: '+',
        title: 'Meaningful Gifting Experience',
        subtitle: 'Buy handmade gifts online that carry emotional value and real impact.  '
    },
    {
        icon: 'fa-heart',
        value: "Trust",
        suffix: '%',
        title: 'Safe & Reliable Platform',
        subtitle: 'Secure payments and reliable delivery available worldwide.'
    }
]


const CounterSection = () => {
    return (
        <>
            {counterBlog.map((data, i) => (
                <div className="col-lg-3 col-md-6 col-sm-6 col-6" key={i} >
                    <div className="icon-bx-wraper style-2 m-b30 text-center">
                        <div className="icon-bx-lg">
                            <i className={`fa-solid icon-cell ${data.icon}`}></i>
                        </div>
                        <div className="icon-content">
                            <div className="dz-title counter m-b0 font-22"> <strong>{data.value}</strong></div>
                            <p className="font-20 mb-0">{data.title}</p>
                            <p className="font-14">{data.subtitle}</p>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}
export default CounterSection;